
import { useRoutes } from 'react-router-dom';
import routes from './router/config';
import CustomAssistantButton from './components/feature/CustomAssistantButton';
import { BrowserRouter } from 'react-router-dom';

function App() {
  const element = useRoutes(routes);
  
  return (
    <>
      {element}
      <CustomAssistantButton />
    </>
  );
}

function AppWithRouter() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <App />
    </BrowserRouter>
  );
}

export default AppWithRouter;
